// Shared E-E-A-T schema definitions for site-wide consistency

export const SITE_NAME = "RoiDuStreaming";
export const SITE_URL = "https://roidustreaming.fr";
export const SITE_LOGO = "https://roidustreaming.fr/favicon.png";
export const SUPPORT_EMAIL = "contact@roidustreaming.fr";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: SITE_LOGO,
  description: "Service IPTV premium avec +100 000 films, +25 000 séries et +16 000 chaînes TV en 4K HDR.",
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: SUPPORT_EMAIL,
    availableLanguage: ["French", "English"],
  },
  sameAs: [],
};

export const publisherSchema = {
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: {
    "@type": "ImageObject",
    url: SITE_LOGO,
  },
};

/**
 * Generate an Article JSON-LD schema for programmatic SEO pages.
 */
export function buildArticleSchema({
  headline,
  description,
  url,
  imageUrl,
  datePublished,
  dateModified,
  section,
}: {
  headline: string;
  description: string;
  url: string;
  imageUrl?: string | null;
  datePublished: string;
  dateModified?: string;
  section: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    url,
    ...(imageUrl && { image: imageUrl }),
    datePublished,
    dateModified: dateModified || datePublished,
    author: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
    publisher: publisherSchema,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    articleSection: section,
  };
}

/**
 * Format an ISO date to a human-readable French date.
 */
export function formatDateFr(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
